export function Form({
  onsubmit,
  children,
  className,
}: {
  children: React.ReactNode;
  onsubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  className?: string;
}) {
  return (
    <form
      className={className}
      onSubmit={(e) => {
        e.preventDefault();
        onsubmit(e);
      }}
    >
      {children}
    </form>
  );
}
